import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { AutomotiveAftermarketReportFacade } from './automotive-aftermarket-report.facade';

@Injectable({
  providedIn: 'root',
})
export class AutomotiveAftermarketReportGuard {
  constructor(private automotiveAftermarketReportFacade: AutomotiveAftermarketReportFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return checkStoreState(this.automotiveAftermarketReportFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.automotiveAftermarketReportFacade);
  }
}
